import { useState, useEffect } from 'react'

const usePagination = (page, key, urlGroup = undefined) => {
  const [dataMap, setDataMap] = useState({})
  useEffect(() => {
    page && setDataMap({ ...dataMap, [page]: { key, urlGroup } })
  }, [page, key])
  return dataMap
}

export default usePagination
